import Pusher from "pusher-js";

const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY!, {
  cluster: process.env.REACT_APP_PUSHER_CLUSTER!,
});

export const subscribeToChannel = (
  channelName: string,
  eventName: string,
  callback: (data: any) => void,
) => {
  const channel = pusher.subscribe(channelName);
  channel.bind(eventName, callback);

  return () => {
    channel.unbind(eventName, callback);
    pusher.unsubscribe(channelName);
  };
};

export const triggerEvent = (
  channelName: string,
  eventName: string,
  data: any,
) => {
  pusher.send_event(eventName, data, channelName);
};
